import { apiClient, handleResp } from './utils';
export default {
  doGetCardDesigned(category) {
    return handleResp(
      apiClient().post('/card_designs', {
        category,
      }),
    );
  },
  doSubmitCard(dataInput) {
    return handleResp(apiClient().post('/order_cards', dataInput));
  },
  doGetCard(dataInput) {
    return handleResp(apiClient().post('/card_orders', dataInput));
  },
};
